import { InjectionToken } from "@angular/core";

export interface WeatherEndpoints {
    getWeatherConditions: string;
    getMissionPlanWeather: string;
    getSupportedWeatherZones: string;
    getDarWeatherConditions: string;
}
export const WEATHER_ENDPOINTS = new InjectionToken<WeatherEndpoints>("Weather endpoints");
